import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

const scopeSetting = [
  //權限與相對應動作
  {
    scope: ['checklist-read'],
    actions:['checklist-result'],
    pages: ['checklistResult', 'checklists'],
  },
  {
    scope: [
      'checklist-record-checker',
      'checklist-record-manager'
    ],
    actions:[
      'checklistAssignmentDraft',
      'checklistAssignment',
      'futureChecklistAssignment',
    ],
    pages: ['checklistAssignment', 'checklistAssignmentTemporary'],
  },
  {
    scope: ['checklist-review-record'],
    actions:['bereview-result'],
    pages: [],
  },
  {
    scope: ['checklist-review-record'],
    actions: ['review-result', 'review-assignment'],
    pages: ['reviewerChecklist'],
  },
  {
    scope: ['alert-read'],
    actions: ['alert-read'],
    pages: ['alertContent', 'alerts'],
  },
  {
    scope: ['task-read', 'task-read-all'],
    actions: ['task-read'],
    pages: ['tasks'],
  },
  {
    scope: ['act-inquiry'],
    actions: ['act-inquiry'],
    pages: ['actContent'],
  },
];
export default {
  $_isHasScope(allScopes, examScopeList, justNeedPartialScope = false) {
    if (!examScopeList || !examScopeList.length) return false;
    if (!allScopes || !allScopes.length) return false;
    const scopeSet = allScopes instanceof Set ? allScopes : new Set(allScopes);
    if (scopeSet.has('wall-passer')) return true;
    const check = justNeedPartialScope
      ? Array.prototype.some
      : Array.prototype.every;
    return check.call(examScopeList, scope => scopeSet.has(scope));
  },
  $_isAvailable(scopeList, params, justNeedPartialScope = false) {
    //判斷是否擁有權限，socpeList為array ["act-read"]，裡面包權限名稱
    if (!scopeList || !scopeList.length) return false;
    if (store.state.stone_auth.isAdministrator) return true;
    const scopesFactories = store.state.auth.scopes.factory;
    const factoryId = params?.factoryId
      ? params.factoryId
      : store.state.app.factoryId;
    if (!scopesFactories || !factoryId) return true;
    const tarFactory = scopesFactories.find(factory => factory.id == factoryId);
    return tarFactory
      ? this.$_isHasScope(tarFactory.scopes, scopeList, justNeedPartialScope)
      : false;
  },
  $_isAvailableAction(action) {
    //判斷動作與相對應的權限
    const scope = scopeSetting.find(scope => scope.actions.includes(action));
    if (!scope) return true;
    return this.$_isAvailable(scope.scope, null, true);
  },
  $_isAvailablePage(page) {
    //判斷頁面與相對應權限
    const scope = scopeSetting.find(scope => scope.pages.includes(page.name));
    if (!scope) return true;
    return this.$_isAvailable(scope.scope, page.params, true);
  },
  $_invalidPopupOpen(setting, type = 'action') {
    //setting -> page,action
    //判斷有沒有權限
    const is_scope = type === 'action'
      ? this.$_isAvailableAction(setting)
      : type === 'page'
      ? this.$_isAvailablePage(setting)
      : true;
    if (is_scope) return true;
    //打開無權限popup
    store.dispatch('error/setErrorMessage', 'invalid scopes');
    store.dispatch('error/setErrorTrue');
    if (type === 'action') {
      store.dispatch('error/setIsOperationalTrue');
    }
  },
  isScopeAvailable(tarScopeList, examScopeArr) {
    return tarScopeList.some(tarScope => examScopeArr[tarScope]);
  },
  isScopeAndUserAvailable(examScopeArr, examUserId) {
    const currentUserId = store.state.stone_auth.currentUser.id;
    return this.$_isAvailable(examScopeArr) && examUserId == currentUserId;
  },
  isMultiScopeAndUserAvailable(type, data) {
    const creatorId = data && data.creator
      ? data.creator.id
      : data && data.created_user
      ? data.updated_user.id
      :null;
    const ownerId = data && data.owner ? data.owner.id : null;
    const takerId = data && data.taker ? data.taker.id : null;
    const reminderId = data && data.reminder ? data.reminder.id : null;
    const examScopeAndUserIdList = [{
      scope: type
    }];
    if (creatorId) {
      examScopeAndUserIdList.push({
        scope: `${type}-creator`,
        id: creatorId
      });
    }
    if (
      type === "contractor-update" || type === "contractor-delete" ||
      type === "event-update" || type === "event-delete" ||
      type === "contractor-enter-record-update" || type === "contractor-enter-record-delete" ||
      type === "audit-update" || type === "audit-delete" ||
      type === "checklist-update" || type === "checklist-delete" ||
      type === "common-choice-update" || type === "common-choice-destroy" ||
      type === "role-update" || type === "role-delete" ||
      type === "guideline-admin-update" || type === "guideline-admin-destroy" ||
      type === "qrcode-update" || type === "qrcode-delete" ||
      type === 'meeting-update' || type === 'meeting-destroy'
    ) {
      if (ownerId) {
        examScopeAndUserIdList.push({
          scope: `${type}-owner`,
          id: ownerId
        });
      }
    }
    if (type === "task-update" || type === "task-delete") {
      if (takerId) {
        examScopeAndUserIdList.push({
          scope: `${type}-taker`,
          id: takerId
        });
      }
    }
    if (type === "contractor-license-update" || type === "contractor-license-delete") {
      if (reminderId) {
        examScopeAndUserIdList.push({
          scope: `${type}-reminder`,
          id: reminderId
        });
      }
    }
    if (type === "contract-update" || type === "contract-delete") {
      if (reminderId) {
        examScopeAndUserIdList.push({
          scope: `${type}-owner`,
          id: reminderId
        });
      }
    }
    if (type === "license-update" || type === "license-delete") {
      if (reminderId) {
        examScopeAndUserIdList.push({
          scope: `${type}-reminder`,
          id: reminderId
        });
      }
      if (takerId) {
        examScopeAndUserIdList.push({
          scope: `${type}-reminder`,
          id: takerId
        });
      }
    }
    if (type === "internal-training-update" || type === "internal-training-delete") {
      if (takerId || ownerId) {
        examScopeAndUserIdList.push({
          scope: `${type}-principal`,
          id: takerId
        });
      }
      if (creatorId) {
        examScopeAndUserIdList.push({
          scope: `${type}-creator`,
          id: creatorId
        });
      }
    }
    let isAvailable = false;
    examScopeAndUserIdList.forEach(item => {
      if (isAvailable) return;
      isAvailable = item.id
        ? this.isScopeAndUserAvailable([item.scope], item.id)
        : this.$_isAvailable([item.scope]);
    });
    return isAvailable;
  },
  async createBatchScopes(data) {
    return await base.create({
      parentName: 'factory',
      parentId: store.state.app.factory.id,
      modelName: 'batch/scopes',
      data,
    });
  },
  async getUserScopes(params) {
    const factoryId = store.state.app.factory.id;
    const {factory: tarFactoryId, user: userId} = params;
    return await base.index({
      url: `factory/${factoryId}/target_factory/${tarFactoryId}/user/${userId}`
    });
  },
  isFactoryAvailable(examFactoryId) {
    const hasScopeFactoryList = store.state.auth.scopes.factory;
    return hasScopeFactoryList.some(factory => factory.id === examFactoryId);
  },
  async getMultiUsersScopes(params) {
    const factoryId = store.state.app.factory.id;
    const _params = {
      factory: factoryId,
      ...params,
    };
    return await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'get_users_scopes',
      params: _params,
    });
  },
};
